import { Button, FormControl, Grid2, MenuItem } from "@mui/material";

import { useMutation } from "@tanstack/react-query";
import { GKModal, GKSelect, GKTextField, SmallSpinner } from "components";
import PhoneInput from "components/PhoneInput";
import { useFormik } from "formik";
import { useState } from "react";
import toast from "react-hot-toast";
import axiosInstance from "utils/axiosInstance";
import { ACCOUNTS_STATUS } from "utils/constants";
import { object, string } from "yup";

const CreateAdvisorModal = ({ setOpen, open, refetch }: any) => {
  // const [hasError, setHasError] = useState(false);
  const [countryCode, setCountryCode] = useState("91");

  const advisorSchema = object({
    // phone: string()
    //   .required("Please enter Phone Number")
    //   .matches(/^[0-9]{10}$/, "Phone number should be 10 digits"),
    email: string().email("Enter valid email").required("Email is required"),
    account_type: string().required("Please select account type"),
  });

  const { mutate: createAdvisor, isLoading } = useMutation({
    mutationKey: ["CREATE_ADVISOR"],
    mutationFn: (values: any) =>
      axiosInstance.post(`/super_admin/create_advisor/`, values),
    onSuccess: (response) => {
      refetch();
      setOpen(false);
      toast.success(response?.data?.message || "Create Advisor Successfully");
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
  });

  const formik = useFormik({
    initialValues: {
      phone: "",
      email: "",
      account_type: "",
      country_code: "+",
    },
    validationSchema: advisorSchema,
    onSubmit: (values: any) => {
      const data = {
        phone: values.phone.toString(),
        email: values.email.toString(),
        account_type: values.account_type.toString(),
        country_code: countryCode,
      };

      createAdvisor(data);
    },
  });

  return (
    <GKModal
      modalTitle="Create Advisor"
      open={open}
      setOpen={setOpen}
      footer={
        <>
          <Grid2
            container
            size={12}
            gap={1}
            display={"flex"}
            justifyContent={"right"}
          >
            <Button
              variant="outlined"
              size="medium"
              onClick={() => setOpen(false)}
            >
              close
            </Button>
            <Button
              variant="contained"
              type="submit"
              size="medium"
              form="add-advisor-form"
            >
              {isLoading ? <SmallSpinner /> : "Create Advisor"}
            </Button>
          </Grid2>
        </>
      }
    >
      <form id="add-advisor-form" onSubmit={formik.handleSubmit}>
        <Grid2 container spacing={2}>
          <Grid2 size={6}>
            <FormControl variant="standard" fullWidth>
              <PhoneInput
                inputLabel="Phone"
                onSelectChange={(e: any, val: any) => {
                  const code = val?.callingCodes || "";
                  setCountryCode(code.startsWith("+") ? code : `+${code}`);
                }}
                onTextChange={(event: any) =>
                  formik.handleChange({
                    target: {
                      name: "phone",
                      value: event.target.value,
                    },
                  })
                }
                onSelectValue={
                  countryCode.startsWith("+") ? countryCode : `+${countryCode}`
                }
                onTextValue={formik.values.phone}
                error={
                  Boolean(formik.errors.phone) && Boolean(formik.touched.phone)
                }
                helperText={
                  Boolean(formik.touched.phone) &&
                  Boolean(formik.errors.phone) &&
                  `${formik.errors.phone}`
                }
              />
            </FormControl>
          </Grid2>

          <Grid2 size={6}>
            <FormControl variant="standard" fullWidth>
              <GKSelect
                inputLabel="Select Account Type"
                onChange={formik.handleChange}
                value={formik.values.account_type}
                name="account_type"
                required
              >
                {ACCOUNTS_STATUS.map((dataItem, i) => (
                  <MenuItem key={i} value={dataItem.value}>
                    {dataItem.name}
                  </MenuItem>
                ))}
              </GKSelect>
            </FormControl>
          </Grid2>

          <Grid2 size={6}>
            <FormControl variant="standard" fullWidth>
              <GKTextField
                inputLabel="Email"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                required
                error={
                  Boolean(formik.errors.email) && Boolean(formik.touched.email)
                }
                helperText={
                  Boolean(formik.touched.email) &&
                  Boolean(formik.errors.email) &&
                  `${formik.errors.email}`
                }
              />
            </FormControl>
          </Grid2>
        </Grid2>
      </form>
    </GKModal>
  );
};

export default CreateAdvisorModal;
